import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Account = (props) => {
  const { height, width, stroke, className } = props;
  return (
    <svg
      id="account"
      width={width}
      height={height}
      stroke={stroke}
      className={className}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="13" cy="7.5" r="3.5" strokeWidth="2" />
      <path
        d="M5.43808 19.2815C6.52301 16.1479 9.50029 13.9 13 13.9C16.4997 13.9 19.477 16.1479 20.5619 19.2815C20.7012 19.6838 20.6055 20.0449 20.3352 20.3448C20.0469 20.6647 19.5596 20.9 19 20.9H7C6.44045 20.9 5.9531 20.6647 5.66476 20.3448C5.39448 20.0449 5.29879 19.6838 5.43808 19.2815Z"
        strokeWidth="2"
      />
    </svg>
  );
};
/* eslint-enable max-len */

Account.defaultProps = {
  className: null,
};

Account.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  stroke: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Account;
